import { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import _, { capitalize } from 'lodash';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';

const CustomBookingFieldsFilter = ({ onSearch }) => {
  const { tripsSearch } = useSelector((store) => store.trip);

  const options = useMemo(() => {
    if (
      tripsSearch.filterObj.customFilters &&
      Object.keys(tripsSearch.filterObj.customFilters).length
    ) {
      return _.map(tripsSearch.filterObj.customFilters, (value, key) => ({ label: key, value }));
    }
    return [];
  }, [tripsSearch.filterObj.customFilters]);

  const handleChange = useCallback(
    (selectedOptions, itemLabel) => {
      const currentCustomBookingFields = tripsSearch.searchObj.customBookingFields || [];
      const existingIndex = currentCustomBookingFields.findIndex(
        (field) => field.key === itemLabel,
      );
      let updatedCustomBookingFields;
      if (!selectedOptions.length) {
        updatedCustomBookingFields = currentCustomBookingFields.filter(
          (field) => field.key !== itemLabel,
        );
      } else if (existingIndex > -1) {
        const updatedEntry = { key: itemLabel, value: selectedOptions };
        updatedCustomBookingFields = [
          ...currentCustomBookingFields.slice(0, existingIndex),
          updatedEntry,
          ...currentCustomBookingFields.slice(existingIndex + 1),
        ];
      } else {
        const newEntry = {
          key: itemLabel,
          value: selectedOptions.filter((value) => typeof value === 'string'),
        };
        updatedCustomBookingFields = [...currentCustomBookingFields, newEntry];
      }

      const searchObj = {
        ...tripsSearch.searchObj,
        customBookingFields: updatedCustomBookingFields,
        page: 1,
      };
      onSearch(searchObj);
    },
    [onSearch, tripsSearch.searchObj],
  );

  return options && options.length > 0 ? (
    options.map((option) => {
      const customOptions = [];
      option.value.forEach((value) => {
        customOptions.push({
          value,
          label: value,
        });
      });
      const field =
        tripsSearch.searchObj.customBookingFields &&
        tripsSearch.searchObj.customBookingFields.find((fields) => fields.key === option.label);
      const values = field ? field.value : [];
      return (
        <CheckboxSelectFilter
          key={option.value}
          onChange={(selectedOptions) => handleChange(selectedOptions, option.label)}
          options={customOptions}
          values={values}
          label={capitalize(option.label)}
          variant="outline"
          filterMaxWidthClass="max-w-full"
          optionDifferentLabel
          selectedValuePrefix={`${capitalize(option.label)}: `}
        />
      );
    })
  ) : (
    <></>
  );
};

CustomBookingFieldsFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};
export default memo(CustomBookingFieldsFilter);
